import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import GetInTouchForm from "./sections/GetInTouchForm";
import OfficeDetails from "./sections/OfficeDetails";
import ClientTestimonials from "./sections/ClientTestimonials";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactHero />
      <GetInTouchForm />
      <OfficeDetails />
      <ClientTestimonials />
      <FinalCallToAction />
      <Footer />
    </div>;
}